import React, { useContext, useCallback } from 'react'
import { Link } from 'rebass'

import { useTranslation } from 'i18n'
import SBox from './opinionless/SBox'
import SText from './opinionless/SText'
import { useSTheme } from '../styles/theme'

import { useAuth } from 'v2/hooks/useAuth'
import { UserContext } from 'v2/context/user'

import SIcon from './opinionless/SIcon'

import WebsiteSvg from '@svgs/lb_website_logo.svg'
import InstagramSvg from '@svgs/lb_instagram_logo.svg'
import TwitterSvg from '@svgs/lb_twitter_logo.svg'
import FacebookSvg from '@svgs/lb_facebook_logo.svg'

import { Container, PolicyEngineLogo, SocialIcons, StyledF4GILogo, StyledPatternImage } from './styles'
import { SPageType } from './opinionless/SPage'
import ConditionalRender from 'utils/conditionalRender'

interface Props {
    pageType: SPageType
}

const BrandedSideBarLongBeach: React.FC<Props> = (props: Props) => {
    const { t } = useTranslation(window.LANG_NS)
    const theme = useSTheme()

    const websiteLink = window.ORGANIZATION_CONFIGS?.websiteLink
    const instagramLink = window.ORGANIZATION_CONFIGS?.instagramLink
    const twitterLink = window.ORGANIZATION_CONFIGS?.twitterLink
    const facebookLink = window.ORGANIZATION_CONFIGS?.facebookLink

    const { authenticatedUser } = useContext(UserContext)

    const { logoutUser } = useAuth()

    const onClickSignOut = useCallback(
        (event) => {
            event.preventDefault()
            void logoutUser()
        },
        [logoutUser]
    )

    const openPage = () => {
        window.open('https://longbeachpledge.org/', '_blank')
    }

    return (
        <Container
            sx={{
                width: '100%',
                height: '100%',
            }}
        >
            <ConditionalRender if={window.innerWidth >= 900}>
                <StyledPatternImage
                    sx={{ minHeight: '100%', height: 'auto' }}
                    src={theme.images.sideBarImage}
                    alt={'pattern image'}
                />

                <StyledF4GILogo
                    padding={20}
                    src={theme.logos.mainLogo}
                    width="100%"
                    height="auto"
                    alt={'logo'}
                    onClick={(e) => openPage()}
                />
                {props.pageType === 'Wizard' ? (
                    <PolicyEngineLogo padding={24} src={theme.logos.policyEngineLogo} alt={'policy engine'} />
                ) : null}
                <SBox flex={1} />
                <SBox flex={'0 0 auto'} style={{ zIndex: 1 }}>
                    <SText p={6} color={'white'}>
                        <StyledF4GILogo
                            paddingRight={45}
                            paddingBottom={3}
                            width="100%"
                            height="auto"
                            src={
                                'https://storage.googleapis.com/portal-web-resources/Long%20Beach/F4GI_LongBeach_side_logo.svg'
                            }
                            alt={'logo'}
                        />
                        <SocialIcons>
                            {websiteLink && (
                                <Link target="__blank" href={websiteLink} height={20}>
                                    <SIcon icon={WebsiteSvg} size={24} mr={3} tintColor="white" />
                                </Link>
                            )}
                            {twitterLink && (
                                <Link target="__blank" href={twitterLink} height={20}>
                                    <SIcon icon={TwitterSvg} size={24} mr={3} tintColor="white" />
                                </Link>
                            )}
                            {facebookLink && (
                                <Link target="__blank" href={facebookLink} height={20}>
                                    <SIcon icon={FacebookSvg} size={24} mr={3} tintColor="white" />
                                </Link>
                            )}
                            {instagramLink && (
                                <Link target="__blank" href={instagramLink} height={20}>
                                    <SIcon icon={InstagramSvg} size={24} mr={3} tintColor="white" />
                                </Link>
                            )}
                        </SocialIcons>
                        <SText
                            fontSize={2}
                            mt={5}
                            mb={3}
                            sx={{
                                whiteSpace: 'pre-line',
                            }}
                            style={{ fontFamily: theme.fonts.terms }}
                        >
                            {t('side_bar_bottom_copyright')}
                        </SText>
                        <SText fontSize={2} mb={3} style={{ fontFamily: theme.fonts.terms }}>
                            {t('side_bar_bottom_f4gi_description')}
                        </SText>
                        {authenticatedUser && (
                            <SText
                                fontSize={2}
                                mt={3}
                                onClick={onClickSignOut}
                                sx={{ cursor: 'pointer' }}
                                id="sign-out-button"
                            >
                                {t('side_bar_button_sign_out')}
                            </SText>
                        )}
                    </SText>
                </SBox>
            </ConditionalRender>
        </Container>
    )
}

export default BrandedSideBarLongBeach
